module.exports = __webpack_public_path__ + "img/sms-hot.a498d241.svg";